/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Compose_Also_FilledInputs */



/**
* | output |
* | --- |
* | "Uno also filled in the instructions on the next step." |
*
* @param {Uno_Compose_Also_FilledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_compose_also_filled = /** @type {((inputs?: Uno_Compose_Also_FilledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Compose_Also_FilledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Uno hat außerdem die Anweisungen im nächsten Schritt ausgefüllt.")
	return /** @type {LocalizedString} */ ("Uno also filled in the instructions on the next step.")
});